import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "as-content-page as-match-detail",
  ref: "asMatchDetail"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "as-h-100"
}
const _hoisted_4 = {
  key: 2,
  class: "as-h-100"
}
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { key: 4 }
const _hoisted_7 = { key: 5 }
const _hoisted_8 = { key: 8 }
const _hoisted_9 = { key: 9 }
const _hoisted_10 = { key: 10 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgSprite = _resolveComponent("SvgSprite")!
  const _component_TabsIcon = _resolveComponent("TabsIcon")!
  const _component_IframeChat = _resolveComponent("IframeChat")!
  const _component_FootStatsList = _resolveComponent("FootStatsList")!
  const _component_H2hListSkeleton = _resolveComponent("H2hListSkeleton")!
  const _component_StatisticsList = _resolveComponent("StatisticsList")!
  const _component_StatisticsListSkeleton = _resolveComponent("StatisticsListSkeleton")!
  const _component_IncidentsList = _resolveComponent("IncidentsList")!
  const _component_IncidentsListSkeleton = _resolveComponent("IncidentsListSkeleton")!
  const _component_LineupTab = _resolveComponent("LineupTab")!
  const _component_LineupTabSkeleton = _resolveComponent("LineupTabSkeleton")!
  const _component_StandingListTab = _resolveComponent("StandingListTab")!
  const _component_StandingListTabSkeleton = _resolveComponent("StandingListTabSkeleton")!
  const _component_H2hList = _resolveComponent("H2hList")!
  const _component_NextMatchList = _resolveComponent("NextMatchList")!
  const _component_MatchOther = _resolveComponent("MatchOther")!
  const _component_Data = _resolveComponent("Data")!
  const _component_OddTab = _resolveComponent("OddTab")!
  const _component_Information = _resolveComponent("Information")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SvgSprite),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_TabsIcon, {
        tabs: _ctx.tabs,
        activeTab: _ctx.activeTab,
        isMin: _ctx.isChatTyping,
        onChange: _ctx.changeTab
      }, null, 8, ["tabs", "activeTab", "isMin", "onChange"]),
      _createElementVNode("div", {
        id: "as-match-detail-content",
        class: _normalizeClass(["as-match-detail-content", {
        'as-hide-content': _ctx.isHideContent,
      }]),
        style: _normalizeStyle({
        height: `${_ctx.heightContent}px`,
      })
      }, [
        _withDirectives(_createElementVNode("div", null, [
          _createVNode(_component_IframeChat)
        ], 512), [
          [_vShow, _ctx.activeTab === 'chat']
        ]),
        (_ctx.activeTab === 'footStats')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_Transition, {
                name: "as-fade",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (_ctx.tabLoading.footStats)
                    ? (_openBlock(), _createBlock(_component_FootStatsList, {
                        key: 0,
                        match: _ctx.match,
                        footyStats: _ctx.footStats
                      }, null, 8, ["match", "footyStats"]))
                    : (_openBlock(), _createBlock(_component_H2hListSkeleton, { key: 1 }))
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.activeTab === 'statistics')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_Transition, {
                name: "as-fade",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (_ctx.tabLoading.statistics)
                    ? (_openBlock(), _createBlock(_component_StatisticsList, {
                        key: 0,
                        match: _ctx.match,
                        statistics: _ctx.statistics,
                        isTabCenter: true
                      }, null, 8, ["match", "statistics"]))
                    : (_openBlock(), _createBlock(_component_StatisticsListSkeleton, { key: 1 }))
                ]),
                _: 1
              })
            ]))
          : (_ctx.activeTab === 'overview')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_Transition, {
                  name: "as-fade",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (_ctx.tabLoading.overview)
                      ? (_openBlock(), _createBlock(_component_IncidentsList, {
                          key: 0,
                          match: _ctx.match,
                          incidents: _ctx.incidents
                        }, null, 8, ["match", "incidents"]))
                      : (_openBlock(), _createBlock(_component_IncidentsListSkeleton, { key: 1 }))
                  ]),
                  _: 1
                })
              ]))
            : (_ctx.activeTab === 'lineups')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_ctx.tabLoading.lineups)
                    ? (_openBlock(), _createBlock(_component_LineupTab, {
                        key: 0,
                        match: _ctx.match,
                        lineups: _ctx.lineups
                      }, null, 8, ["match", "lineups"]))
                    : (_openBlock(), _createBlock(_component_LineupTabSkeleton, { key: 1 }))
                ]))
              : (_ctx.activeTab === 'standing')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_Transition, {
                      name: "as-fade",
                      mode: "out-in"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.tabLoading.standing)
                          ? (_openBlock(), _createBlock(_component_StandingListTab, {
                              key: 0,
                              match: _ctx.match,
                              standing: _ctx.standing
                            }, null, 8, ["match", "standing"]))
                          : (_openBlock(), _createBlock(_component_StandingListTabSkeleton, { key: 1 }))
                      ]),
                      _: 1
                    })
                  ]))
                : (_ctx.activeTab === 'h2h')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_Transition, {
                        name: "as-fade",
                        mode: "out-in"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.tabLoading.h2h || _ctx.tabLoading.next_match || _ctx.isObjectNotEmpty(_ctx.h2h))
                            ? (_openBlock(), _createBlock(_component_H2hList, {
                                key: 0,
                                match: _ctx.match,
                                h2h: _ctx.h2h,
                                isTabCenter: true
                              }, null, 8, ["match", "h2h"]))
                            : (_openBlock(), _createBlock(_component_H2hListSkeleton, { key: 1 }))
                        ]),
                        _: 1
                      })
                    ]))
                  : (_ctx.activeTab === 'next_match')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 6,
                        class: _normalizeClass(`as-tab-btn-center as-parent-h2h as-parent-h2h-${_ctx.siteName}`)
                      }, [
                        _createVNode(_Transition, {
                          name: "as-fade",
                          mode: "out-in"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.tabLoading.h2h || _ctx.tabLoading.next_match || _ctx.isObjectNotEmpty(_ctx.h2h))
                              ? (_openBlock(), _createBlock(_component_NextMatchList, {
                                  key: 0,
                                  match: _ctx.match,
                                  h2h: _ctx.h2h
                                }, null, 8, ["match", "h2h"]))
                              : (_openBlock(), _createBlock(_component_H2hListSkeleton, { key: 1 }))
                          ]),
                          _: 1
                        })
                      ], 2))
                    : (_ctx.activeTab === 'match_other')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 7,
                          class: _normalizeClass(`as-parent-h2h as-parent-h2h-${_ctx.siteName}`)
                        }, [
                          _createVNode(_Transition, {
                            name: "as-fade",
                            mode: "out-in"
                          }, {
                            default: _withCtx(() => [
                              (_ctx.tabLoading.match_other)
                                ? (_openBlock(), _createBlock(_component_MatchOther, {
                                    key: 0,
                                    matchLiveData: _ctx.matchOtherData,
                                    matchId: _ctx.matchId
                                  }, null, 8, ["matchLiveData", "matchId"]))
                                : (_openBlock(), _createBlock(_component_H2hListSkeleton, { key: 1 }))
                            ]),
                            _: 1
                          })
                        ], 2))
                      : (_ctx.activeTab === 'data')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createVNode(_component_Data, {
                              match: _ctx.match,
                              data: _ctx.data
                            }, null, 8, ["match", "data"])
                          ]))
                        : (_ctx.activeTab === 'odd')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createVNode(_component_OddTab, {
                                odd: _ctx.odd,
                                oddOld: _ctx.oddOld,
                                tabKey: _ctx.tabKey.odd
                              }, null, 8, ["odd", "oddOld", "tabKey"])
                            ]))
                          : (_ctx.activeTab === 'information')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createVNode(_component_Information, { match: _ctx.match }, null, 8, ["match"])
                              ]))
                            : _createCommentVNode("", true)
      ], 6)
    ], 512)
  ], 64))
}